export default {
    navConstants: {
        autoNavTypes: {
            none: "None",
            mainPage: "MainPage",
            popup: "Popup",
        },
        defaultWindowFeatures: '',
        enableCurrentPageMatching: true,
        hoverText: {
            urlHoverTextPath: "DisplayText",
        },
        hoverTextPath: "DisplayText",
        linkTypes: {
            none: "None",
            mainPage: 'MainPage',
            popup: 'Popup',
        },
        targetTypes: {
            input: 'input',
            unit: 'unit',
            url: 'url',
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/nav-constants.ts